import { TokenService } from '../application/services/TokenService';
import { setContext } from '@apollo/client/link/context';

/**
 * Creates an Apollo auth link that adds the authentication token to GraphQL requests
 * @param tokenService The token service to use for retrieving the token
 * @returns Apollo auth link middleware
 */
export const createApolloAuthLink = (tokenService: TokenService) => {
  return setContext((_, { headers }) => {
    const token = tokenService.getToken();
    return {
      headers: {
        ...headers,
        ...(token && { Authorization: `rca ${token}` }),
      },
    };
  });
};
